// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ADD_FEED_POST = "Pridaj diskusiu";
export const SEO_DESCRIPTION_FORUM = "Diskusn\u00e9 miesto pre mami\u010dky pln\u00e9 sk\u00fasenosti, r\u00e1d, tipov a trikov priamo z prvej ruky. Miesto ka\u017edodenn\u00fdch radost\u00ed a starost\u00ed, ktor\u00e9 nie je o ide\u00e1lnych mami\u010dk\u00e1ch, ale o skuto\u010dnom \u017eivote.";
export const SEO_TITLE_FORUM = "Diskusie o de\u0165och, tehotenstve a rodine";
export const TAB_FORUMS = "F\u00f3ra";
export const TAB_GROUPS = "Skupiny";
